import React from "react";
import { Row, Col, Typography } from "antd";
import moment from "moment";
import { formatTime } from "../../utils/time";

const { Text } = Typography;

const ProductPeriod = ({ time }) => {
  if (!time) {
    return null; // Return null if time is not provided
  }

  const saleStartDate = time.sale?.start ? formatTime(time.sale.start, "YYYY-MM-DD") : "N/A";
  const saleEndDate = time.sale?.end ? formatTime(time.sale.end, "YYYY-MM-DD") : "N/A";
  const redeemStartDate = time.redeem?.start ? formatTime(time.redeem.start, "YYYY-MM-DD") : "N/A";
  const redeemEndDate = time.redeem?.end ? formatTime(time.redeem.end, "YYYY-MM-DD") : "N/A";

  return (
    <Row style={{ width: "100%" }}>
      {time.sale ? (
        <>
          <Col span={8}>
            <Text strong>Sale Period: </Text>
          </Col>
          <Col span={16}>
            <Text>{`${saleStartDate} to ${saleEndDate}`}</Text>
          </Col>
        </>
      ) : null}

      <br />

      {time.redeem ? (
        <>
          <Col span={8}>
            <Text strong>Redeem Period: </Text>
          </Col>
          <Col span={16}>
            <Text>{`${redeemStartDate} to ${redeemEndDate}`}</Text>
          </Col>
        </>
      ) : null}
    </Row>
  );
};

export default ProductPeriod;
